// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import useAppStateStore from "../../../shared/store/AppStateStore";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const Tq2Mapper = {
  get() {
    const STATE = useAppStateStore.getState();
    const driver = useQuoteStore.getState().quote?.risk?.drivers?.[0] ?? {};
    const lookupAddress = STATE.lookupAddress;

    return {
      email: driver.emailAddress ?? null,
      phone: driver.telephone ?? null,
      house: driver.address?.houseNo ?? "",
      address: driver.address?.houseNo ?? "",
      lookUpAddress: lookupAddress ?? null,
      city: driver.address?.city ?? "",
      county: driver.address?.county ?? "",
      postcode: driver.address?.postcode ?? "",
      timeAtAddress: driver.timeAtAddress ?? "",
      residentialStatus: driver.residentialStatus
        ? { value: driver.residentialStatus }
        : null,
      maritalStatus: driver.maritalStatus
        ? { value: driver.maritalStatus }
        : null,
      employmentStatus: driver.employmentStatus
        ? { value: driver.employmentStatus }
        : null,
      occupation: driver.occupation ? { value: driver.occupation } : null,
      businessType: driver.businessType ? { value: driver.businessType } : null,
      Rating: driver.uberDriverRatingId
        ? { value: driver.uberDriverRatingId }
        : null,
    };
  },

  // Setter function to update the driver data in the store
  set(data) {
    const STATE = useAppStateStore.getState();
    const setLookupAddress = STATE.setLookupAddress;
    updateQuoteFields({
      "risk.drivers.0.emailAddress": data.email,
      "risk.drivers.0.telephone": data.phone,
      "risk.drivers.0.address.city":
        data.lookUpAddress?.city ?? data?.city ?? "",
      "risk.drivers.0.address.county":
        data.lookUpAddress?.county ?? data?.county ?? "",
      "risk.drivers.0.address.houseNo":
        data.lookUpAddress?.house ?? data?.house ?? "",
      "risk.drivers.0.address.street":
        data.lookUpAddress?.street ?? data?.street ?? "",
      "risk.drivers.0.address.postcode":
        data.lookUpAddress?.postcode ?? data?.postcode ?? "",
      "risk.drivers.0.uberDriverRatingId": data.Rating?.value ?? "",
    });
    setLookupAddress(data.lookUpAddress ?? null);
  },
};

export default Tq2Mapper;
